import React from 'react';

export default function ChevronDown(props: any) {
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.47266 7.22266C7.12109 7.57422 6.59375 7.57422 6.27734 7.22266L0.652344 1.59766C0.300781 1.28125 0.300781 0.753906 0.652344 0.4375C0.96875 0.0859375 1.49609 0.0859375 1.8125 0.4375L6.83984 5.46484L11.9023 0.402344C12.2188 0.0859375 12.7461 0.0859375 13.0625 0.402344C13.4141 0.753906 13.4141 1.28125 13.0625 1.59766L7.47266 7.22266Z"
        fill="currentColor"
      />
    </svg>
  );
}
